export function copyToClipboard(str) {
  // Use modern Clipboard API if available
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(str).catch((err) => {
      console.log("Clipboard API failed, falling back to execCommand", err);
      copyToClipboardFallback(str);
    });
    return;
  }

  copyToClipboardFallback(str);
}

function copyToClipboardFallback(str) {
  try {
    var el = document.createElement("textarea");
    el.value = str;
    el.style.position = "absolute";
    el.style.left = "-9999px";
    el.setAttribute("readonly", "");
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  } catch (err) {
    console.log(err);
  }
}
